import { defineStore } from "pinia";
import { useToursDAO } from "../entities/tours";

export const useTourResultsStore = defineStore("tourResults", () => {
  const { tours, $find, $read } = useToursDAO();

  return { tours, $find, $read };
});
